import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Mail } from "lucide-react";
import { FAQ, SITE } from "../../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="glow-blob absolute bottom-0 -right-40 w-[460px] h-[460px] rounded-full bg-violet-200/40" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
      <SectionHeading
        center
        label="FAQ"
        title="Questions fréquentes"
        description="Formules, réservation, examen : tout ce que nos élèves de Chatou nous demandent le plus souvent."
      />

      <div className="grid md:grid-cols-2 gap-5 mt-12 items-start" data-testid="faq-accordion">
        {[FAQ.slice(0, 3), FAQ.slice(3)].map((col, c) => (
          <Accordion key={c} type="single" collapsible className="space-y-4">
            {col.map((item, i) => {
              const idx = c * 3 + i;
              return (
                <AccordionItem
                  key={idx}
                  value={`item-${idx}`}
                  className="border border-slate-100 border-b-0 rounded-2xl bg-white px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
                  data-testid={`faq-item-${idx}`}
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${idx}`}
                    className="text-left font-heading font-bold text-slate-900 text-sm sm:text-base py-5 hover:text-violet-700 hover:no-underline [&[data-state=open]>svg]:text-violet-700 [&[data-state=open]>svg]:rotate-45"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-500 text-sm leading-relaxed pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex justify-center" data-testid="faq-contact-note">
          <div className="inline-flex flex-col items-center gap-3 rounded-2xl bg-white/70 border border-slate-100 px-8 py-6">
            <Mail size={22} className="text-slate-700" />
            <p className="text-sm text-slate-500">
              Une question ? Contactez-nous à :{" "}
              <a href={`mailto:${SITE.email}`} className="font-bold text-violet-700 hover:underline" data-testid="faq-email-link">
                {SITE.email}
              </a>
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
